// extracted by mini-css-extract-plugin
export default {"bell-icon":"CampaignPopUp_bell-icon__5is42","title":"CampaignPopUp_title__lS8fu","alert":"CampaignPopUp_alert__0mPKq","close-btn":"CampaignPopUp_close-btn__pgSZH"};